
         <button *ngIf="isRedMobile" (click)="openSwipeCardWindow()" class=" mb-3" pButton type="button"
         label="העבר כרטיס" icon="swipeCardIcon" ></button>
<div class="form-group creditCard" [formGroup]="formGroup" >
    <div class="p-field p-float-label ltr"  style="display: flex;">

        <input class="creditInput"  id="creditCard" pInputText name="creditCard" formControlName="CreditCard"
            autocomplete="cc-number" maxlength="23" #ccNumber class="w-full creditInput" (keyup)="creditCardNumberSpacing()"
            (blur)="onBlur()" type="tel"/>
        <label for="creditCard" style="direction: rtl;">
            <!-- showSwipeButton || isInKehilot -->
            {{isInKehilot && !isRedMobile? ('CREDIT_CARD.SWIPE_CARD' | translate) : ('CREDIT_CARD.CREDIT_NUMBER' | translate)}}

        </label>
        <p class="issuerImg" [ngClass]="currentIssuer"></p>

    </div>
</div>
<!-- CreditCard -->


